import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './VendorList.css'; // Import CSS

const VendorList = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await axios.get('https://pink-dragonfly-673605.hostingersite.com/api/auth/registerlistvendors'); // Update the base URL if needed
        setVendors(response.data.vendors);
      } catch (error) {
        console.error('Error fetching vendors:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchVendors();
  }, []);

  if (loading) return <p className="vendor-list-container">Loading vendors...</p>;

  return (
    <div className="vendor-list-container">
      <h2>Registered Vendors</h2>
      {vendors.length === 0 ? (
        <p>No vendors found.</p>
      ) : (
        <table className="vendor-table">
          <thead>
            <tr>
              <th>Email</th>
              <th>Business Name</th>
              <th>Contact Number</th>
              <th>Logo</th>
            </tr>
          </thead>
          <tbody>
            {vendors.map((vendor) => (
              <tr key={vendor._id}>
                <td>{vendor.email}</td>
                <td>{vendor.businessName}</td>
                <td>{vendor.contactNumber}</td>
                <td>
                  {vendor.logo?.url ? (
                    <img
                      src={vendor.logo.url}
                      alt="Logo"
                      className="vendor-logo"
                    />
                  ) : (
                    'No logo'
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default VendorList;
